import React, { useState, useEffect } from 'react';
import { makeStyles, useMediaQuery, Select, FormControl, MenuItem, InputLabel, Paper, Typography, Button, Menu, Tooltip } from "@material-ui/core";
import { customTheme } from "./customTheme";
import config from "./config.json";
import moment from "moment";
import notify from './components/CustomUseNotify';
import ParkingSearchSelector from './components/ParkingSearchSelector';
import { useLocation } from 'react-router-dom';
import CustomDateTimePicker from "./components/CustomDateTimePickerV4";
import { AnalyticDistributionImgs, ParkingsIncludeHelmetType } from "./sharedData";
import { saveTokens } from './utils/saveTokens';
import Skeleton from '@material-ui/lab/Skeleton';
import queryString from 'query-string';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ShowTimePeriod from './components/ShowTimePeriod';
// import CustomFilter from './components/CustomFilter';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    dialogPaper: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        maxWidth: 350
    },
    dialogButton: {
        borderRadius: 100,
        padding: "8px 25px"
    },
    dialogPaperBig: {
        borderRadius: 15,
        padding: "5px 5px 10px",
    },
    input: {
        width: "500px"
    },
    MuiInputBase: {
        root: {
            width: "800px"
        }
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "inline-block",
        borderRadius: 50,
        minWidth: 100,
    },
    timeFilterContainer: {
        alignItems: "center",
        marginTop: customTheme.spacing(5),
    },
    timeFilterInput: {
        marginLeft: "2%",
    },
    outlinedInput: {
        padding: 0,
    },
    timeFilterButton: {
        marginLeft: "1%",
        width: "10%",
        minWidth: 85
    },
    summaryListRoot: {
        marginTop: customTheme.spacing(2),
    },
    summaryCardContainer: {
        display: "grid",
        gridAutoFlow: "column",
        marginTop: customTheme.spacing(3),
    },
    flexContainer: {
        display: 'flex',
        alignItems: "center",
    },
    listActions: {
        justifyContent: "space-between",
        marginTop: customTheme.spacing(3),
    },
    mainTableCell: {
        color: `${customTheme.palette.grey[900]} !important`,
        fontWeight: 500,
    },
    listVehicleIcon: {
        width: 25,
        height: 25,
        marginRight: customTheme.spacing(1),
        verticalAlign: "middle",
    },
    showLayoutMain: {
        marginTop: 0,
    },
    showTitle: {
        fontSize: 22,
    },
    searchParamsTitle: {
        fontSize: "1.05rem",
    },
    searchParams: {
        fontFamily: "Poppins-Regular",
        fontSize: "0.95rem",
    },
    asyncSelector: {
        display: "grid",
        gridAutoFlow: "column",
        justifyContent: "space-between",
        paddingRight: 5,
    },
    removeMargin: {
        margin: 0,
    },
    parkingListHead: {
        color: customTheme.palette.grey[500],
    },
    inlineForm: {
        display: "grid",
        gridAutoFlow: "column",
        padding: "18px 2%",
        marginLeft: 15
    },
    removeUnderline: {
        borderBottom: "none",
    },
    checkIconButton: {
        borderRadius: 4,
        padding: "5px 5px 2px",
        '&:hover': {
            backgroundColor: "#0001 !important",
            cursor: "pointer",
        },
    },
    smallSelectRoot: {
        padding: "10px 32px 10px 18px",
    },
    receiptTextContainer: {
        display: "flex",
        padding: "15px 20px",
        '&:hover': {
            backgroundColor: "#00336608",
        },
        alignItems: "center",
        marginBottom: 15,
        border: "1px solid #bfbfbf",
        borderRadius: 4,
    },
    selectWithIcon: {
        display: "flex",
        justifyContent: "space-between",
        paddingLeft: 20,
        paddingRight: "40px !important",
        columnGap: 30,
    },
    editSummaryTime: {
        color: "#888",
        fontSize: 20,
        marginLeft: 10,
        '&:hover': {
            cursor: "pointer",
            opacity: 0.7,
        }
    },
    backDrop: {
        backgroundColor: "#00000042"
    },
    statusCircle: {
        width: 7,
        height: 7,
        borderRadius: 10,
    },
    columnLink: {
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
            cursor: 'pointer',
        }
    },
    timeRangeButton: {
        flex: 1,
        padding: "10px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            cursor: "pointer",
            backgroundColor: "#eee"
        }
    },
    title: {
        fontSize: 13,
        color: customTheme.palette.secondary.main,
    },
    mainValue: {
        fontSize: 28,
        color: customTheme.palette.primary.main,
        fontWeight: customTheme.typography.fontWeightMedium
    },
    summaryBox: {
        padding: customTheme.spacing(3, 3),
    },
    twoColumnGrid: {
        padding: customTheme.spacing(1, 0, 2),
        display: "grid",
    },
    summaryVehicleIcon: {
        width: 18
    },
    summaryBoxLabel1: {
        fontSize: 12,
        color: "#A3BBD9",
        margin: customTheme.spacing(0, 2, 0, 1),
    },
    summaryBoxLabel2: {
        fontSize: 12,
        color: "#A3BBD9",
        margin: customTheme.spacing(0, 2, 0, 1),
    },
    paymentSummaryBoxLabel1: {
        fontSize: 12,
        color: customTheme.palette.grey[500],
    },
    summaryBoxValue1: {
        fontSize: 12,
        color: "#334D6E",
        fontWeight: customTheme.typography.fontWeightMedium
    },
    tooltip: {
        fontSize: 9,
        fontFamily: "Poppins-Regular",
        fontWeight: "normal"
    }
});

let gateSummaryInitState = {
    "data": {
        "Entry": {
            "types": {
                "ANPR": {
                    "total": 0,
                    "percentage": 0
                },
                "CASH": {
                    "total": 0,
                    "percentage": 0
                },
                "FASTag": {
                    "total": 0,
                    "percentage": 0
                }
            },
            "totalSum": 0
        },
        "Exit": {
            "types": {
                "FASTag": {
                    "total": 0,
                    "percentage": 0
                },
                "CASH": {
                    "total": 0,
                    "percentage": 0
                }
            },
            "totalSum": 0
        },
        "Amount": {
            "types": {
                "FASTag": {
                    "total": 0,
                    "percentage": 0
                },
                "CASH": {
                    "total": 0,
                    "percentage": 0
                }
            },
            "totalSum": 0
        },
        "Not Exited": {
            "types": {
                "FASTag": {
                    "total": 0,
                    "percentage": 0
                },
                "CASH": {
                    "total": 0,
                    "percentage": 0
                }
            },
            "totalSum": 0
        }
    },
    "loading": true,
    "isInitState": true
}

let totalPaymentSummaryInitState = {
    "data": {
        "types": {
            "Issues": {
                "vehicleTypes": {
                    "4": {
                        "count": 0,
                        "amount": 0
                    },
                    "2": {
                        "count": 0,
                        "amount": 0
                    }
                },
                "amount": 0
            },
            "Recharge": {
                "vehicleTypes": {
                    "4": {
                        "count": 0,
                        "amount": 0
                    },
                    "2": {
                        "count": 0,
                        "amount": 0
                    }
                },
                "amount": 0
            },
        },
        "totalSum": 23
    },
    "loading": true,
    "isInitState": true
}

const progressBarColor = ["#16CC69", "#5E8DD3", "#334D6E", "#F7685B", "#16CC69", "#5E8DD3", "#334D6E", "#F7685B"]

const ParkingAnalytics = () => {
    //const notify = useNotify();
    const classes = useStyles();
    const location = useLocation();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [reduceSummary] = useState(isNaN(sessionStorage.getItem("reduce_summary")) || sessionStorage.getItem("reduce_summary") === '0' || sessionStorage.getItem("reduce_summary") === 0 ? '' : sessionStorage.getItem("reduce_summary"));
    // const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const [gatesSummary, setGatesSummary] = React.useState(gateSummaryInitState);
    const [selectedGateType, setSelectedGateType] = useState('')
    const [selectedTypeGateSummary, setSelectedTypeGateSummary] = React.useState({ loading: false, data: {}, isInitState: true });
    const [totalPaymentSummary, setTotalPaymentSummary] = React.useState(totalPaymentSummaryInitState);
    const [totalVehicleFlowSummary, setTotalVehicleFlowSummary] = React.useState(totalPaymentSummaryInitState)
    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);
    const [currentParking, setCurrentParking] = useState({});
    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));



    // const [showMonthlyPass] = React.useState(sessionStorage.getItem('show_monthly_pass') === "1")
    // const [showPermit] = React.useState(sessionStorage.getItem('show_rfid') === "1")

    const [gateAnchor, setGateAnchor] = React.useState(null);
    const [gateTypes, setGateTypes] = React.useState(sessionStorage.getItem("gate_types") ? sessionStorage.getItem("gate_types") : "Vehicle");

    const [totalPaymentTypesAnchor, setTotalPaymentTypesAnchor] = useState(null)
    const [totalPaymentTypes, setTotalPaymentTypes] = useState(sessionStorage.getItem("total_payment_types") ? sessionStorage.getItem("total_payment_types") : "Vehicle")

    const [vehicleFlowTypesAnchor, setVehicleFlowTypesAnchor] = useState(null)
    const [vehicleFlowTypes, setVehicleFlowTypes] = useState(sessionStorage.getItem("vehicle_flow_types") ? sessionStorage.getItem("vehicle_flow_types") : "Vehicle")
    const [hideMonthlyWiseDateFilter] = useState(sessionStorage.getItem("hide_monthly_wise_date_filter") === '1');
    const [hideCustomDateFilter] = useState(sessionStorage.getItem("hide_custom_date_filter") === '1');
    const [hideTimeFilter] = useState(sessionStorage.getItem("hide_time_filter") === '1');
    const [dateTillYesterday] = useState(sessionStorage.getItem("date_till_yesterday") === '1');

    const handleClickGateTypes = (event) => setGateAnchor(event.currentTarget);
    const handleCloseGateTypes = () => setGateAnchor(null);

    const handleClickTotalPaymentTypes = (event) => setTotalPaymentTypesAnchor(event.currentTarget);
    const handleCloseTotalPaymentTypes = () => setTotalPaymentTypesAnchor(null);

    const handleClickVehicleFlowTypes = (event) => setVehicleFlowTypesAnchor(event.currentTarget);
    const handleCloseVehicleFlowTypes = () => setVehicleFlowTypesAnchor(null);

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const onTotalPaymentTypesChange = (type) => {
        setTotalPaymentTypes(type)
        sessionStorage.setItem('total_payment_types', type);
        handleCloseTotalPaymentTypes()
    }

    const onVehicleFlowTypesChange = (type) => {
        setVehicleFlowTypes(type)
        sessionStorage.setItem('vehicle_flow_types', type);
        handleCloseVehicleFlowTypes()
    }

    const onGateTypesChange = (type) => {
        setGateTypes(type)
        sessionStorage.setItem('gate_types', type);
        handleCloseGateTypes()
    }

    const getTotalPaymentSummary = () => {
        setTotalPaymentSummary({ loading: true, data: totalPaymentSummaryInitState.data, isInitState: true });
        const params = {
            access_key_id: currentParking.id,
            parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined,
            start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
            end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
            type: totalPaymentTypes === "Vehicle" ? "vehicle" : "payment"
        }
        fetch(`${config.HOST_NAME}/crm/parkingAnalytics/payments?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        }).then(response => {
            saveTokens(response)
            return response.json()
        })
            .then(responseJson => {
                console.log(responseJson)
                if (responseJson.success) setTotalPaymentSummary({ loading: false, data: responseJson.data, isInitState: false });
                else notify(responseJson.message, 'warning');
            })
            .catch((e) => {
                console.log(e)
                notify('Error Fetching Summary', 'warning')
            });
    }

    const getGateSummary = () => {
        setGatesSummary({ loading: true, data: gateSummaryInitState.data, isInitState: true })
        const params = {
            access_key_id: currentParking.id,
            parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined,
            start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
            end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
            type: gateTypes === "Vehicle" ? "vehicle" : "entry/exit"
        }
        fetch(`${config.HOST_NAME}/crm/parkingAnalytics/allGates?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        }).then(response => {
            saveTokens(response)
            return response.json()
        })
            .then(responseJson => {
                if (responseJson.success) setGatesSummary({ loading: false, data: responseJson.data, isInitState: false });
                else notify(responseJson.message, 'warning');
            })
            .catch((e) => {
                console.log(e)
                notify('Error Fetching Summary', 'warning')
            });
    }

    const getSelectedTypeGateSummary = () => {
        setSelectedTypeGateSummary({ loading: true, data: {}, isInitState: true })
        const params = {
            access_key_id: currentParking.id,
            parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined,
            start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
            end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
            type: gateTypes === "Vehicle" ? "vehicle" : "entry/exit"
        }
        fetch(`${config.HOST_NAME}/crm/parkingAnalytics/gatewise?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        }).then(response => {
            saveTokens(response)
            return response.json()
        })
            .then(responseJson => {
                if (responseJson.success) setSelectedTypeGateSummary({ loading: false, data: responseJson.data, isInitState: false });
                else notify(responseJson.message, 'warning');
            })
            .catch((e) => {
                console.log(e)
                notify('Error Fetching Summary', 'warning')
            });
    }

    const getTotalVehicleFlowSummary = () => {
        setTotalVehicleFlowSummary({ loading: true, data: totalPaymentSummaryInitState.data, isInitState: true });
        const params = {
            access_key_id: currentParking.id,
            parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined,
            start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
            end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
            type: vehicleFlowTypes === "Vehicle" ? "vehicle" : "category"
        }
        fetch(`${config.HOST_NAME}/crm/parkingAnalytics/vehicleFlow?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        }).then(response => {
            saveTokens(response)
            return response.json()
        })
            .then(responseJson => {
                if (responseJson.success) setTotalVehicleFlowSummary({ loading: false, data: responseJson.data, isInitState: false });
                else notify(responseJson.message, 'warning');
            })
            .catch((e) => {
                console.log(e)
                notify('Error Fetching Summary', 'warning')
            });
    }

    useEffect(() => {
        if (currentParking && currentParking.id && Object.keys(currentParking).length > 0 && startDateTime && endDateTime) {
            getTotalPaymentSummary()
        }
    }, [currentParking, startDateTime, endDateTime, totalPaymentTypes]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (currentParking && currentParking.id && Object.keys(currentParking).length > 0 && startDateTime && endDateTime) getTotalVehicleFlowSummary()
    }, [currentParking, startDateTime, endDateTime, vehicleFlowTypes]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (currentParking && currentParking.id && Object.keys(currentParking).length > 0 && startDateTime && endDateTime) getGateSummary()
        if (selectedGateType && startDateTime && endDateTime) getSelectedTypeGateSummary()
    }, [currentParking, startDateTime, endDateTime, gateTypes]); // eslint-disable-line react-hooks/exhaustive-deps

    // useEffect(() => {
    //     // if (!showFilter) {
    //     //     getTotalPaymentSummary()
    //     //     getGateSummary()
    //     // }
    //     // else 
    //     if (currentParking && currentParking.id && Object.keys(currentParking).length > 0 && startDateTime && endDateTime) {
    //         if (showMonthlyPass || showPermit) getTotalPaymentSummary()
    //         getTotalVehicleFlowSummary()
    //         getGateSummary()
    //     }
    //     if (selectedGateType && startDateTime && endDateTime) getSelectedTypeGateSummary()
    // }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0 }}>

                <ParkingSearchSelector
                    value={currentParking}
                    onChange={onParkingChange}
                    clearable={true}
                    pathName={location.pathname}
                />

                {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                    <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                        <InputLabel>Zone Name</InputLabel>
                        <Select
                            value={currentParking.allZones ? "All" : currentParking.id}
                            onChange={onZoneChange}
                            label="Zone Name"
                            variant="outlined"
                        >
                            <MenuItem value="All">All</MenuItem>
                            {finalZones.map((zone, index) => (
                                <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
            </div>

            <div className='customStyleForDataSearchDiv'>
                <CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} hideCustomDate = {hideCustomDateFilter} hideMonthlyDate = {hideMonthlyWiseDateFilter} hideTimeFilter = {hideTimeFilter} dateTillYesterday={dateTillYesterday} />
                {/* <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} /> */}
            </div>
            <ShowTimePeriod startDateTimeFilter={startDateTime} endDateTimeFilter={endDateTime} />
            {currentParking && currentParking.id ?
                <>

                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", justifyContent: "space-between", gap: 15, marginTop: 10 }}>
                        <TotalSummaryCard title="Total Payment" totalPaymentSummary={totalPaymentSummary} showTotalAmount={true} open={totalPaymentTypesAnchor} types={totalPaymentTypes} onTypesChange={onTotalPaymentTypesChange} handleClick={handleClickTotalPaymentTypes} handleClose={handleCloseTotalPaymentTypes} options={["Vehicle", "Payment"]} currentParking={currentParking} />
                        <TotalSummaryCard title="Total Vehicle Flow" totalPaymentSummary={totalVehicleFlowSummary} open={vehicleFlowTypesAnchor} types={vehicleFlowTypes} onTypesChange={onVehicleFlowTypesChange} handleClick={handleClickVehicleFlowTypes} handleClose={handleCloseVehicleFlowTypes} options={["Vehicle", "Category"]} isPaymentType={false} currentParking={currentParking} />
                    </div>
                    {!reduceSummary &&
                        <>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
                                <div className='secondaryColor fontWeightSemiBold' style={{ fontSize: 14 }}>All Gate Analysis</div>
                                <div>
                                    <Button className='fontWeightMedium' aria-controls={Boolean(gateAnchor) ? "city-menu" : undefined} aria-expanded={Boolean(gateAnchor) ? "true" : undefined} onClick={handleClickGateTypes}
                                        style={{ display: "flex", justifyContent: "center", alignItems: "center", border: "1px", color: "#5E8DD3", backgroundColor: "#109CF11A", textTransform: "none", fontSize: 9, fontWeight: "normal", padding: "0 7px 0px 15px", height: 20 }}>
                                        <div>{`By ${gateTypes} Type`} </div>
                                        <div><ArrowDropDownIcon /></div>
                                    </Button>
                                    <Menu anchorEl={gateAnchor} open={Boolean(gateAnchor)} onClose={handleCloseGateTypes}>
                                        <MenuItem onClick={() => onGateTypesChange("Vehicle")}>Vehicle</MenuItem>
                                        <MenuItem onClick={() => onGateTypesChange("Entry-Exit")}>Entry-Exit</MenuItem>
                                    </Menu>
                                </div>
                            </div>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", justifyContent: "space-between", gap: 15, marginTop: 10 }}>
                                {
                                    Object.keys(gatesSummary.data).map((value) => (
                                        <SummaryCard
                                            title={value}
                                            data={gatesSummary.data[value]["types"]}
                                            getValue={data => gatesSummary.data[value]["totalSum"]}
                                            getDistributedLabels={data => Object.keys(data).map(val => AnalyticDistributionImgs[val === "5" && ParkingsIncludeHelmetType.includes(currentParking.access_key) ? "11" : val === "7" && ParkingsIncludeHelmetType.includes(currentParking.access_key) ? "12" : val]?.["label"])}
                                            getDistributedValues={data => Object.keys(data).map(val => data[val].count ? data[val].count : 0)}
                                            getDistributedIcons={data => Object.keys(data).map(val => AnalyticDistributionImgs[val === "5" && ParkingsIncludeHelmetType.includes(currentParking.access_key) ? "11" : val === "7" && ParkingsIncludeHelmetType.includes(currentParking.access_key) ? "12" : val]?.["img"])}
                                            getDistributedValuePercentage={data => Object.keys(data).map(val => data[val].percentage ? data[val].percentage : 0)}
                                            getDistributedPercentage={data => Object.keys(data).map((val, i) => {
                                                return { percentage: data[val].percentage ? data[val].percentage.toFixed(2) : 0, color: progressBarColor[i] }
                                            })}
                                            loading={gatesSummary.loading}
                                            showDonutChart={true}
                                            showProgressBar={true}
                                            clickable={() => {
                                                setSelectedGateType(value)
                                                getSelectedTypeGateSummary()
                                            }}
                                        />
                                    ))
                                }
                            </div>

                            {selectedGateType && !selectedTypeGateSummary.loading && Object.keys(selectedTypeGateSummary.data) &&
                                Object.keys(selectedTypeGateSummary.data).map((value) => (
                                    <div style={{ marginTop: 10 }}>
                                        <div className='secondaryColor fontWeightSemiBold' style={{ fontSize: 14 }}>{value}</div>

                                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", justifyContent: "space-between", gap: 15, marginTop: 10 }}>
                                            {
                                                Object.keys(selectedTypeGateSummary.data[value]).map((val) => (
                                                    <SummaryCard
                                                        title={val}
                                                        data={selectedTypeGateSummary.data[value][val]["types"]}
                                                        getValue={data => selectedTypeGateSummary.data[value][val]["totalSum"]}
                                                        getDistributedLabels={data => Object.keys(data).map(val => AnalyticDistributionImgs[val === "5" && ParkingsIncludeHelmetType.includes(currentParking.access_key) ? "11" : val === "7" && ParkingsIncludeHelmetType.includes(currentParking.access_key) ? "12" : val]?.["label"])}
                                                        getDistributedValues={data => Object.keys(data).map(val => data[val].count ? data[val].count : 0)}
                                                        getDistributedIcons={data => Object.keys(data).map(val => AnalyticDistributionImgs[val === "5" && ParkingsIncludeHelmetType.includes(currentParking.access_key) ? "11" : val === "7" && ParkingsIncludeHelmetType.includes(currentParking.access_key) ? "12" : val]?.["img"])}
                                                        getDistributedPercentage={data => Object.keys(data).map((val, i) => {
                                                            return { percentage: data[val].percentage ? data[val].percentage.toFixed(2) : 0, color: progressBarColor[i] }
                                                        })}
                                                        getSubPercentage={data => selectedTypeGateSummary.data[value][val]["percentage"] ? selectedTypeGateSummary.data[value][val]["percentage"].toFixed(2) : 0}
                                                        getDistributedValuePercentage={data => Object.keys(data).map(val => data[val].percentage ? data[val].percentage : 0)}
                                                        loading={gatesSummary.loading}
                                                        showDonutChart={true}
                                                        showProgressBar={true}
                                                        showTooltip={true}
                                                    />
                                                ))
                                            }
                                        </div>
                                    </div>
                                ))
                            }

                            {selectedGateType && selectedTypeGateSummary.loading &&
                                [1, 2, 3, 4].map((value) => (
                                    <div style={{ marginTop: 10 }}>
                                        <Skeleton variant="text" height={22} width="34%" />

                                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", justifyContent: "space-between", gap: 15, marginTop: 10 }}>
                                            {
                                                [1, 2, 3, 4].map((val) => (
                                                    <SummaryCard
                                                        title={""}
                                                        data={""}
                                                        getValue={data => ""}
                                                        getDistributedLabels={data => ""}
                                                        getDistributedValues={data => ""}
                                                        getDistributedIcons={data => ""}
                                                        getDistributedValuePercentage={data => ""}
                                                        getDistributedPercentage={data => Object.keys(data).map((val, i) => {
                                                            return ""
                                                        })}
                                                        loading={true}

                                                    />
                                                ))
                                            }
                                        </div>
                                    </div>
                                ))
                            }
                        </>
                    }
                </>
                : <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px 18px 20px", marginTop: 10 }}>
                    <div style={{ color: "#334D6E", fontSize: 13, fontFamily: "Poppins-Medium" }}>Please select a Parking.</div>
                </Paper>
            }
        </div>
    )
}

export default ParkingAnalytics

function SummaryCard({ title, loading, data, getValue, getDistributedValues, getDistributedLabels, getDistributedIcons, getDistributedPercentage, getDistributedValuePercentage, getSubPercentage, getDistributedAmount, showDonutChart, clickable, showProgressBar = false, getDistributedCount, showTooltip = false, getNestedTypes = null, isPaymentType = true, style }) {
    const classes = useStyles();
    const clickableHandler = () => {
        if (clickable) clickable()
    }

    return <Paper onClick={clickableHandler} style={{ position: "relative", display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px 18px 20px", cursor: clickable ? "pointer" : "", ...style }}>
        <div style={{ flex: 1 }}>
            <div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography className={classes.title} style={{ textTransform: "capitalize" }}>{title}</Typography>
                </div>
                {
                    !loading && data ?
                        <div style={{ display: "flex", gap: 10, alignItems: getSubPercentage && (getSubPercentage(data) || getSubPercentage(data) === 0) ? "center" : "", flexWrap: "wrap" }}>
                            {getDistributedCount && getDistributedCount(data) && <Typography className={classes.mainValue} style={{ color: "#334D6E", marginRight: 10 }}>{getDistributedCount(data)}</Typography>}
                            <Typography className={classes.mainValue}>{["Amount"].includes(title) ? "₹" : ""} {getValue(data)}</Typography>
                            {getSubPercentage && (getSubPercentage(data) || getSubPercentage(data) === 0) &&
                                <div style={{ display: "flex", alignItems: "center", backgroundColor: "#18CC6919", fontSize: 9, color: "#18CC69", padding: "0px 10px", height: 15, borderRadius: 10, fontFamily: "Poppins-SemiBold" }}>
                                    {getSubPercentage(data)}%
                                </div>
                            }
                        </div>
                        :
                        !loading && !data ?
                            <div style={{ display: "flex", gap: 10, alignItems: getSubPercentage && (getSubPercentage(data) || getSubPercentage(data) === 0) ? "center" : "", flexWrap: "wrap" }}>
                                <Typography className={classes.mainValue}>{["Amount"].includes(title) ? "₹" : ""} {0}</Typography>
                            </div>
                            :
                            <Skeleton variant="text" height={42} width="34%" />
                }
            </div>
            {
                !loading && data ? getDistributedLabels(data).map((dL, i) => (
                    <div>
                        <div key={dL} className={classes.flexContainer}>
                            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                                <img className={classes.summaryVehicleIcon} src={getDistributedIcons(data)[i]} alt={dL} />
                                <Typography className={classes.summaryBoxLabel1}>{dL}:</Typography>
                            </div>
                            <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", alignItems: "flex-end", gap: 10, flexWrap: "wrap" }}>
                                <Typography className={classes.summaryBoxValue1}>{["Amount"].includes(title) ? "₹" : ""} {getDistributedValues(data)[i]}</Typography>

                                {isPaymentType && getDistributedAmount && getDistributedAmount(data) && <>
                                    <Typography className={classes.summaryBoxValue1} style={{ color: "#18CC69" }}>₹ {getDistributedAmount(data)[i].toFixed(2)}</Typography>                            </>
                                }
                                {!["Manual"].includes(dL) && getDistributedValuePercentage && getDistributedValuePercentage(data) && <>
                                    <Typography className={classes.summaryBoxValue1} style={{ color: "#18CC69", fontSize: 9 }}>{getDistributedValuePercentage(data)[i].toFixed(2)}%</Typography>
                                    {showTooltip && <Tooltip arrow title={`This percentage is the overall share for this gate for ${dL}`} classes={{ tooltip: classes.tooltip }}><InfoOutlinedIcon style={{ fontSize: 12, color: "#888" }} /></Tooltip>}
                                </>
                                }
                            </div>
                        </div>

                        {getNestedTypes && getNestedTypes(data) !== null &&
                            [Object.keys(getNestedTypes(data))[i]].map((val) => (
                                <>
                                    {getNestedTypes(data)[val]["types"] && Object.keys(getNestedTypes(data)[val]["types"]).map((subType) => (
                                        <div key={subType} className={classes.flexContainer} style={{ marginLeft: 20 }}>
                                            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                                                <img className={classes.summaryVehicleIcon} src={AnalyticDistributionImgs[subType]?.["img"]} alt={subType} />
                                                <Typography className={classes.summaryBoxLabel1}>{subType}:</Typography>
                                            </div>
                                            <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", alignItems: "flex-end", gap: 10, flexWrap: "wrap" }}>
                                                <Typography className={classes.summaryBoxValue1}>{getNestedTypes(data)[val]["types"] && getNestedTypes(data)[val]["types"][subType]["count"] ? `${getNestedTypes(data)[val]["types"][subType]["count"]}` : '0'} </Typography>
                                                {isPaymentType && <Typography className={classes.summaryBoxValue1} style={{ color: "#18CC69" }}>{getNestedTypes(data)[val]["types"] && getNestedTypes(data)[val]["types"][subType]["amount"] ? `₹ ${getNestedTypes(data)[val]["types"][subType]["amount"].toFixed(2)}` : '₹ 0'} </Typography>}
                                                <Typography className={classes.summaryBoxValue1} style={{ color: "#18CC69", fontSize: 9 }}>{getNestedTypes(data)[val]["types"] && getNestedTypes(data)[val]["types"][subType]["percentage"] ? getNestedTypes(data)[val]["types"][subType]["percentage"].toFixed(2) : '0'}%</Typography>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            ))
                        }


                    </div>
                )) :
                    !loading && !data ? null
                        :
                        ["50%", "40%"].map((width, index) => (
                            <Skeleton variant="text" width={width} height={18} key={index} />
                        ))
            }
        </div>

        {showProgressBar && data && getDistributedPercentage &&
            <div className="horizontal-bar" style={{ position: "absolute", bottom: 0, left: 0, width: "100%" }}>
                {getDistributedPercentage(data).map((item, index) => (
                    <Tooltip arrow title={`${item.percentage}%`} classes={{ tooltip: classes.tooltip }}>
                        <div key={index} className="bar-segment" style={{ width: `${item.percentage}%`, backgroundColor: item.color }}>
                        </div>
                    </Tooltip>
                ))}
            </div>
        }
    </Paper>

}

function TotalSummaryCard({ title, totalPaymentSummary, showTotalAmount = false, open, types, onTypesChange, handleClick, handleClose, options, isPaymentType = true, currentParking }) {
    const classes = useStyles();

    return <Paper style={{ boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px" }}>
        <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography className={classes.title}>{title}</Typography>

                <div>
                    <Button className='fontWeightMedium' aria-controls={Boolean(open) ? "city-menu" : undefined} aria-expanded={Boolean(open) ? "true" : undefined} onClick={handleClick}
                        style={{ display: "flex", justifyContent: "center", alignItems: "center", border: "1px", color: "#5E8DD3", backgroundColor: "#109CF11A", textTransform: "none", fontSize: 9, fontWeight: "normal", padding: "0 7px 0px 15px", height: 20 }}>
                        <div>{`By ${types} Type`} </div>
                        <div><ArrowDropDownIcon /></div>
                    </Button>
                    <Menu anchorEl={open} open={Boolean(open)} onClose={handleClose}>
                        {options.map((opt) => <MenuItem onClick={() => onTypesChange(opt)}>{opt}</MenuItem>)}
                    </Menu>
                </div>
            </div>
            {isPaymentType && <div style={{ display: "flex", marginTop: 5 }}>
                <Typography className={classes.mainValue}>₹ {totalPaymentSummary.data["totalAmount"]}</Typography>
            </div>
            }
        </div>
        {isPaymentType &&
            <div style={{ marginTop: 5 }}>
                {
                    Object.keys(totalPaymentSummary.data).map((value) => (
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                            {Object.keys(totalPaymentSummary.data[value]).map((v) => (
                                <SummaryCard
                                    title={v}
                                    data={totalPaymentSummary.data[value][v]["types"]}
                                    getValue={data => `₹ ${totalPaymentSummary.data[value][v]["totalAmount"] ? totalPaymentSummary.data[value][v]["totalAmount"] : 0}`}
                                    getDistributedLabels={data => Object.keys(data).map(val => AnalyticDistributionImgs[val === "5" && ParkingsIncludeHelmetType.includes(currentParking.access_key) ? "11" : val === "7" && ParkingsIncludeHelmetType.includes(currentParking.access_key) ? "12" : val]?.["label"])}
                                    getDistributedValues={data => v === "visitors" ? false : Object.keys(data).map(val => data[val].count ? data[val].count : 0)}
                                    // getDistributedValues={data => false}
                                    getDistributedAmount={data => Object.keys(data).map(val => v === "visitors" ? data[val].count ? data[val].count : 0 : data[val].amount ? data[val].amount : 0)}
                                    getDistributedIcons={data => Object.keys(data).map(val => AnalyticDistributionImgs[val === "5" && ParkingsIncludeHelmetType.includes(currentParking.access_key) ? "11" : val === "7" && ParkingsIncludeHelmetType.includes(currentParking.access_key) ? "12" : val]?.["img"])}
                                    // getDistributedCount={data => totalPaymentSummary.data[value][v]["count"]}
                                    getDistributedCount={data => false}
                                    getSubPercentage={data => totalPaymentSummary.data[value][v]["percentage"] ? totalPaymentSummary.data[value][v]["percentage"].toFixed(2) : 0}
                                    getDistributedValuePercentage={data => Object.keys(data).map(val => data[val].percentage ? data[val].percentage : 0)}
                                    getNestedTypes={data => data && data ? data : null}
                                    isPaymentType={isPaymentType}
                                    loading={totalPaymentSummary.loading}
                                    style={{ boxShadow: "none", padding: "0px" }}
                                />
                            ))}
                        </div>
                    ))
                }
            </div>
        }

        {!isPaymentType &&
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginTop: 5 }}>
                {
                    Object.keys(totalPaymentSummary.data).map((value) => (
                        <div>
                            <SummaryCard
                                title={value}
                                data={totalPaymentSummary.data[value]["types"]}
                                getValue={data => totalPaymentSummary.data[value]["count"] ? totalPaymentSummary.data[value]["count"] : 0}
                                getDistributedLabels={data => Object.keys(data).map(val => AnalyticDistributionImgs[val === "5" && ParkingsIncludeHelmetType.includes(currentParking.access_key) ? "11" : val === "7" && ParkingsIncludeHelmetType.includes(currentParking.access_key) ? "12" : val]?.["label"])}
                                getDistributedValues={data => Object.keys(data).map(val => data[val].count ? data[val].count : 0)}
                                getDistributedAmount={data => false}
                                getDistributedIcons={data => Object.keys(data).map(val => AnalyticDistributionImgs[val === "5" && ParkingsIncludeHelmetType.includes(currentParking.access_key) ? "11" : val === "7" && ParkingsIncludeHelmetType.includes(currentParking.access_key) ? "12" : val]?.["img"])}
                                getDistributedCount={data => false}
                                getDistributedValuePercentage={data => Object.keys(data).map(val => data[val].percentage ? data[val].percentage : 0)}
                                getNestedTypes={data => data && data ? data : null}
                                isPaymentType={isPaymentType}
                                loading={totalPaymentSummary.loading}
                                style={{ boxShadow: "none", padding: "0px" }}
                            />
                        </div>
                    ))
                }
            </div>
        }

    </Paper>
}